<template>
  <div class="licenses">
    <div class="licenses__grid">
      <UtilityLicense
        v-for="license in userLicenses"
        :key="'LICENSE__' + license.id"
        :type="license.attributes.resource_type"
        :id="license.id"
        :name="license.attributes.resource_name"
        owner="Tomi Karila"
        validFrom="17/11/19"
        validTo="29/01/25"
        :status="license.attributes.status"
      />
    </div>

    <pre>{{ userLicenses }}</pre>
  </div>
</template>

<script>
import UtilityLicense from '@/components/utility/License.vue'
import config from '@/helpers/config'

export default {
  components: {
    UtilityLicense
  },
  data () {
    return {
      currentView: 'licenses'
    }
  },
  computed: {
    userLicenses () {
      return this.$store.getters['user/getLicenses']
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.licenses {
  @include font('content--md', $white, 0.9);
  width: 90%;
  margin: 0 auto;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
    margin: 0 auto;
  }

  &__grid {
    margin: 2rem auto;
    display: grid;
    grid-gap: 1rem 1.5rem;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }
}

</style>
